export function formatImage(imageUrl: string, width: number, height: number) {
  return imageUrl.replace(imageUrl.split("/")[6], `c_fill,g_south,w_${width},h_${height}`);
}
